import { CASES } from './constants';
import {
    PAGINATION_STORAGE_KEYS,
    DEFAULT_PAGE_SIZE_OPTIONS,
    getStoredItemsPerPage,
    getInitialPaginationRange,
    withPreservedPagination,
    persistItemsPerPage,
} from 'datastage/utils/paginationPreferences.js';

/**
 * Gets the initial items per page from localStorage.
 * Falls back to 25 (Deal Version default) if not found.
 */
const getInitialItemsPerPage = () => {
    return getStoredItemsPerPage(PAGINATION_STORAGE_KEYS.dealVersion, 25);
};

// Initialize with stored preference
const initialItemsPerPage = getInitialItemsPerPage();

/**
 * Initial state for the deal version slice.
 *
 * Key state values:
 * - dealVersions: Array of deal version objects for the grid
 * - filterForm: Search form field values
 * - isDealStatusOpen: Boolean to control deal status drawer visibility
 * - refreshDealVersion: Boolean flag to trigger grid refresh from other components
 * - itemsPerPage: User's persisted page size preference (from localStorage)
 */
const initialState = {
    dealVersions: [],
    filterForm: {
        dealId: '',
        dealTitle: '',
        showSubversions: false,
    },
    isDealStatusOpen: false,
    selectedDeal: '',
    selectedStatus: {
        id: 'Fully_Executed',
        label: 'Fully Executed',
    },
    statusOptions: [
        {
            id: 'Fully_Executed',
            label: 'Fully Executed',
        },
        {
            id: 'Version_Error',
            label: 'Version Error',
        },
    ],
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    rangeParam: getInitialPaginationRange(initialItemsPerPage),
    sortParam: ['id', 'ASC'],
    itemsPerPage: initialItemsPerPage,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    // Flag to trigger grid refresh from other components
    refreshDealVersion: false,
};

export function dealVersion(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_DEAL_VERSION: {
            // Persist page size preference to localStorage
            if (payload.itemsPerPage !== undefined) {
                persistItemsPerPage(PAGINATION_STORAGE_KEYS.dealVersion, payload.itemsPerPage);
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_DEAL_VERSION_SEARCH_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_DEAL_VERSION: {
            // Preserve pagination preferences when clearing
            return withPreservedPagination(
                state,
                initialState,
                ['rangeParam']
            );
        }
        default:
            return state;
    }
}